import { AnyObject } from '@feedyou/utils'

// Caution: This will only work with string keys, numeric/Symbol object keys cannot be sorted!
export const sortObjectKeys = <O extends AnyObject>(
  obj: O,
  sorter: (v1: any, v2: any) => number = (k1, k2) => k1.localeCompare(k2)
): O => {
  const sortedKeys = Object.keys(obj).sort(sorter)

  return sortedKeys.reduce((output, currentObjectKey: keyof O) => {
    output[currentObjectKey] = obj[currentObjectKey]
    return output
  }, {} as O)
}
